(function () {
  'use strict';

  $('.c-tabs').each(function (sectionIndex) {
    var container = $(this),
      tabList = container.find('.c-tabList'),
      sections = container.find('.c-tabContent__content');

    // Create tab list
    for (var i = 0; i < sections.length; i++) {
      var tabHeading = $(sections[i]).find('.heading');
      var headingText = tabHeading.text();
      var s = '<li><a href="#section' + sectionIndex + '-' + i + '" class="c-tabList__tab u-center">' + headingText + '</a></li>'
      tabHeading.remove();
      tabList.append(s);
    }

    var tabs = tabList.find('.c-tabList__tab');
        var tabsOuter = tabList.find('li');

    var switchTab = function (oldTab, newTab) {
      newTab = $(newTab);
      oldTab = $(oldTab);
      newTab.removeAttr('tabindex');
      newTab.focus();
      newTab.attr('aria-selected', 'true');
      oldTab.removeAttr('aria-selected');
      oldTab.attr('tabindex', '-1');
      var newIndex = tabs.index(newTab);
      var oldIndex = tabs.index(oldTab);
      $(sections[oldIndex]).attr('hidden', 'true');
      $(sections[newIndex]).removeAttr('hidden');
    };

    tabList.attr('role', 'tablist');

    tabs.each(function (index) {
      $(this).attr('role', 'tab');
      $(this).attr('id', 'tab' + (index + 1));
      $(this).attr('tabindex', '-1');
      var ariaControls = $(this).attr('href');
      if (ariaControls) {
        ariaControls = ariaControls.substr(1);
        $(this).attr('aria-controls', ariaControls);
      }
      $(this).click(function (e) {
        e.preventDefault();
        var currentTab = tabList.find('[aria-selected]');
        if ($(e.currentTarget).attr('id') !== $(currentTab).attr('id')) {
          switchTab(currentTab, e.currentTarget);
        }
      });

      $(this).keydown(function (e) {
        var index = tabs.index($(e.currentTarget));
        // left, right, or down
        var dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
        if (dir !== null) {
          e.preventDefault();
          dir === 'down' ? sections[index].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
        }
      })
    });

    sections.each(function (index) {
      $(this).attr('role', 'tabpanel');
      $(this).attr('tabindex', '-1');
      $(this).attr('id', 'section' + sectionIndex + '-' + index);
      var id = $(this).attr('id');
      $(this).attr('aria-labelledby', tabs[index].id);
      $(this).attr('hidden', 'true');
    });

    var firstTab = $(tabs[0]);
    firstTab.removeAttr('tabindex');
    firstTab.attr('aria-selected', 'true');
    $(sections[0]).removeAttr('hidden');
      
        var checkForTabOverflow = function() {
          var tabListWidth = tabList.width();
          var tabsWidth = 0;
          
          tabsOuter.each(function(){
            tabsWidth = tabsWidth + $(this).width();
          });
          tabsWidth = Math.floor(tabsWidth); // round down
                    
          if (tabsWidth > tabListWidth) {
            tabList.addClass('c-tabList--scroll');
          } else {
            tabList.removeClass('c-tabList--scroll');
          }
        }
        checkForTabOverflow(); // call on page load
        
        // window resize to check for tab overflow
        var resizeTimer;
        $(window).on('resize', function(e) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            checkForTabOverflow();
          }, 250);
        });

  });
  
  $('.c-filterTabs').each(function () {
      
      var container = $(this);
      var tabs = container.find('.c-filterTabs__tab');
      
      var checkForTabOverflow = function() {
        var containerWidth = container.outerWidth();
        var tabsWidth = 0;

        tabs.each(function(){
          tabsWidth = tabsWidth + $(this).outerWidth();
        });
        tabsWidth = Math.floor(tabsWidth); // round down
        
        if (tabsWidth > containerWidth) {
          container.addClass('c-filterTabs--scroll');
        } else {
          container.removeClass('c-filterTabs--scroll');
        }
      }
      
      checkForTabOverflow();
      
      var resizeTimer;
      $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          checkForTabOverflow();
        }, 250);
      });
      
    });

})();
